import { URL } from "@myloc/myloc-utils";

const endpoint = (url: string, params?: any, version = "intelligence/v1") => {
  const root = () => {
    return (process.env.REACT_APP_API_DOMAIN ?? "") + process.env.REACT_APP_API_PATH;
  };

  const templates = { ...params };

  const preparedUrl = url.replace(/{([^}]+)}/g, (_, key) => templates[key]);

  const baseURI = root();
  const fullPath = `${baseURI}${version}${preparedUrl}`;
  const uri = new URL(fullPath);

  return uri;
};

export const api = {
  qlik: {
    getCookie: (xrfKey: string) => endpoint("jwt/qrs/about?xrfkey={xrfKey}", { xrfKey }, ""),
  },
};
